//@flow
import Enum from 'common/enums/Enum';

const DOCUMENT_STATE = new Enum({
    HIDDEN: 'hidden',
    PRERENDER: 'prerender'
});
export default class DOMUtils {
    static isCurrentTabInactive = () => {
        return (
            document.visibilityState === DOCUMENT_STATE.HIDDEN ||
            document.visibilityState === DOCUMENT_STATE.PRERENDER
        );
    };
}
